<template>
  <div>
  <transition :name="transitionName">
    <router-view class="child-view"></router-view>
  </transition>
  </div>
</template>

<script>
export default {
  name: "newapp",
  data() {
    return {
      transitionName: "slide-left"
    };
  },
  beforeRouteUpdate(to, from, next) {
    let isBack = this.$router.isBack;
    if (isBack) {
      this.transitionName = "slide-right";
    } else {
      this.transitionName = "slide-left";
    }
    this.$router.isBack = false;
    next();
  }
};
</script>

<style>

.child-view {
  position: absolute;
  width: 100%;
  top:0;
  bottom:0;
  overflow-x: hidden;
  /*transition: all 0.8s cubic-bezier(0.55, 0, 0.1, 1);*/
  overflow-scrolling : touch;
  -webkit-overflow-scrolling : touch;
}
.slide-left-enter,
.slide-right-leave-active {
  opacity: 0;
  -webkit-transform: translate(50px, 0);
  transform: translate(50px, 0);
}
.slide-left-leave-active,
.slide-right-enter {
  opacity: 0;
  -webkit-transform: translate(-50px, 0);
  transform: translate(-50px, 0);
}
.header {
  position: absolute;
  height: 44px;
  background: #0058f1;
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/newapp.vue